import { actionTypes } from "./all-service-status.actions";


export interface IAllServiceStatusState {
  isDropOffServiceAvailable: boolean;
  isWellnessServiceAvailable: boolean;
  isIntegratedServiceAvailable: boolean;
  isExpressServiceAvailable: boolean;
  isOnlinePharmacyServiceAvailable: boolean;
  isServiceStatusStoreUpdated: boolean;
  isUrgentCareOnly: boolean;
}

const initialState: IAllServiceStatusState = {
  isDropOffServiceAvailable: false,
  isWellnessServiceAvailable: false,
  isIntegratedServiceAvailable: false,
  isExpressServiceAvailable: false,
  isOnlinePharmacyServiceAvailable: false,
  isServiceStatusStoreUpdated: false,
  isUrgentCareOnly: false,
};


export const allServiceStatusReducer = (
  state: IAllServiceStatusState = initialState,
  action: { type: string, payload: boolean },
) => {
  switch (action.type) {
  case actionTypes.SET_DROPOFF_SERVICE_STATUS:
    return {
      ...state,
      isDropOffServiceAvailable: action.payload,
    };
  case actionTypes.SET_WELLNESS_SERVICE_STATUS:
    return {
      ...state,
      isWellnessServiceAvailable: action.payload,
    };
  case actionTypes.SET_INTEGRATED_SERVICE_STATUS:
    return {
      ...state,
      isIntegratedServiceAvailable: action.payload,
    };
  case actionTypes.SET_EXPRESS_SERVICE_STATUS:
    return {
      ...state,
      isExpressServiceAvailable: action.payload,
    };
  case actionTypes.SET_ONLINE_PHARMACY_SERVICE_STATUS:
    return {
      ...state,
      isOnlinePharmacyServiceAvailable: action.payload,
    };
  case actionTypes.SET_SERVICE_STORE_STATUS_UPDATED:
    return {
      ...state,
      isServiceStatusStoreUpdated: action.payload,
    };
  case actionTypes.SET_IS_URGENT_CARE_ONLY:
    return {
      ...state,
      isUrgentCareOnly: action.payload,
    };
  case actionTypes.RESET_SERVICE_STATUS_STORE:
    return {
      ...initialState,
    };
  default:
    return state;
  }
};
